import Page from 'modules/app/components/Page'
import React from 'react'
import {
  Link, useLocation, useNavigate, useParams,
} from 'react-router-dom'
import useFeedPosts from 'sdk/hooks/feed/useFeedPosts'
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';

import PostView from 'components/shared/PostView';
import styles from './FeedGrid.module.scss';

export default function FeedGrid() {
  const { id, feedId, feedName } = useParams()
  const { state } = useLocation()
  const navigate = useNavigate()

  const feedData = useFeedPosts({ name: feedName || '', id: `${feedId || ''}` }, (id || ''));
  let posts = feedData?.data?.pages.map(
    (v) => v?.results,
  ).flat() || [];

  const uniqueList = (ps: any[]) => {
    const ids = ps.map((p) => p.foreign_id) // @ts-ignore
    const uniqueIds = [...new Set(ids)]
    return uniqueIds.map((i) => ps.find((p) => p.foreign_id === i))
  }

  posts = uniqueList(posts);

  return (
    <Page>
      <div className={styles.container}>
        <div className={styles.headerRow}>
          <Link
            className={styles.h}
            to="/"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            <h1>
              <IconArrowRight />
              { feedName === 'user_feed' ? "Experts videos I'm following" : state?.name }
            </h1>
          </Link>
        </div>
        <div className={styles.playlistPosts}>
          {posts.map((post: any) => (
            <div className={styles.postView} key={post?.id}>
              <PostView
                feedId={feedId}
                feedName={feedName}
                key={post?.id}
                data={post}
                size={1}
              />
            </div>
          ))}
        </div>
      </div>
    </Page>
  )
}
